export default __webpack_public_path__ + "static/media/startupimg.d53a1c36.png";